export interface DuvOptionalDetails {
  club?: string;
  residence?: string;
  nameInNonLatinCharacters?: string;
  yearOfBirth?: string;
}
const text = (value: unknown) => typeof value === 'string' ? value.trim() : '';
/** Prefer the selected edition; do not select an arbitrary value from conflicting documents. */
export function resolveDuvDetails(profiles: Record<string, unknown>[], registrations: Record<string, unknown>[]): DuvOptionalDetails {
  const pick = (keys: string[]) => {
    const values = (rows: Record<string, unknown>[]) => Array.from(new Set(rows.map(row => keys.map(key => ['yearOfBirth', 'birthYear'].includes(key) && typeof row[key] === 'number' && Number.isInteger(row[key]) ? String(row[key]) : text(row[key])).find(Boolean) || '').filter(Boolean)));
    const registered = values(registrations);
    const candidates = registered.length ? registered : values(profiles);
    return candidates.length === 1 ? candidates[0] : '';
  };
  return { club: pick(['club', 'representing']), residence: pick(['residence', 'city', 'postalCity']),
    nameInNonLatinCharacters: pick(['nameInNonLatinCharacters', 'nonLatinName']),
    yearOfBirth: pick(['yearOfBirth']) || pick(['birthYear']) };
}
